import React, { useContext, useState } from 'react';
import { Button, Card, Container, Row, Col } from 'react-bootstrap';
import { FaCheck, FaRegCopy } from 'react-icons/fa';
import { AuthContextProvider } from '../../AuthContext/AuthContext';
import referalgift from '../../assets/images/new/referalgiftfrien.jpeg'
import './ReferAndEarn.css'
import LoginPopUp from '../LoginPopup';
import { t } from 'i18next';
import HoroscopeBannerImg from "../../assets/images/new/faqbanner.png";
const ReferAndEarn = ({ moduleName }) => {
    const userID = localStorage.getItem("userID") || "";
    const referralCode = localStorage.getItem("referralID");
    const [copied, setCopied] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(referralCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    const handleShare = () => {
        if (userID === null || userID === undefined || userID === '') {
            setShowLoginModal(true)
        } else {
            const url = `https://myomnamo.com/Register?RefCode=${referralCode}&From=webapp`;
            //const url = `https://preprod.myomnamo.com//Register?RefCode=${referralCode}&From=webapp`;
            const whatsappURL = `https://wa.me/?text=${encodeURIComponent(
                `Welcome, Friend!\n Create your account to explore a divine collection of spiritual products and sacred services.
              Everything you need for your spiritual journey is here.\n Start your journey with Myomnamo today!\n Use my referral code:\n${url}`
            )}`;


            window.open(whatsappURL, "_blank");
        }

    };
    return (
        <>
            {moduleName !== 'Home' && (
                <section className="page-header" style={{ paddingBottom: '30px' }}>
                    <div
                        className="page-header__bg horoscope-banner-responsive"
                        style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
                    ></div>
                    <div className="container" style={{ display: 'block' }}>
                        <h2 className="page-header__title bw-split-in-left">

                            {t("Invite Your Friends")}
                        </h2>

                    </div>
                </section>
            )}

            <Container className="py-1 reffer-section mobile-responsive-reffer" style={{ width: '100%' }}>
                <Card className=" border-0" >                    <Card.Body className=' reffer-friend'>
                    <Row className="align-items-center">
                        {/* Image Section */}
                        <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
                            <div className="slide-in-left">
                                <img
                                    src={referalgift}
                                    alt="Refer and Earn"
                                    className="img-fluid rounded responsive-img"
                                    style={{ width: '85%' }}
                                />
                            </div>
                        </Col>

                        {/* Text Section */}
                        <Col xs={12} md={6}>
                            <div className="slide-in-right">
                                <h2 className="mb-3 fw-bold text-center text-md-start ">{t("Refer & Earn")}</h2>
                                <p className=" text-center text-md-start">
                                    <strong>{t("Invite Your Friends & Earn")} ₹251! </strong><br />
                                    {t("Share Myomnamo with your friends — you’ll receive ₹251 in your wallet, and you can claim it while booking a puja when they log in for the first time.")}! <br />
                                    {t("Let’s grow our spiritual community together")}.
                                </p>
                                {(referralCode !== null && referralCode !== undefined && referralCode !== '') && (
                                    <div className="d-flex justify-content-center justify-content-md-start align-items-center flex-wrap gap-2 my-3">
                                        <div className="border rounded px-3 py-2 bg-light fw-bold">
                                            {t("Your Referral Code")}: <span className="text-secondary">{referralCode}</span>
                                        </div>
                                        {/* <button className="Normal-app-btn px-3" style={{ fontSize: '14px' }} onClick={handleCopy}>
  {copied ? <FaCheck /> : <FaRegCopy />}
</button> */}
                                    </div>
                                )}


                                <div className="text-center text-lg-start" >

                                    <button className="refer-earn-btn mt-1" style={{ minWidth: '150px' }} onClick={handleShare}>
                                        {t("Invite Now")}
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
                </Card>
            </Container>
            <LoginPopUp show={showLoginModal} onHide={() => setShowLoginModal(false)} />
        </>


    );
};

export default ReferAndEarn;
